import './Team.css';
import member1 from '../Assets/yuva.jpg'; 
import member2 from '../Assets/Lekha.jpg'; 
import member3 from '../Assets/shalini.jpg'; 
import member4 from '../Assets/selvaganapthy.jpg'; 
import member6 from '../Assets/adhikari.jpg'; 
import member7 from '../Assets/member6.jpeg'; 
import member8 from '../Assets/member8.jpeg'; 
function Team() {
  const members = [
    {
      id: 1,
      name: "Yuvabharathi",
      role: "CEO & Founder",
      desc: "Chemical Engineer with 20+ years of expertise in BIS certification and testing equipment design.",
      img: member1,
    },
    {
      id: 2,
      name: "Lekha",
      role: "COO",
      desc: "Expert in BIS, ISI, and CRS certifications with strong government liaison experience.",
      img: member2,
    },
    {
      id: 3,
      name: "Shalini",
      role: "IT Admin",
      desc: "Specializes in documentation, factory inspections, and certification project handling.",
      img: member3,
    },
    {
      id: 4,
      name: "Selvaganapathi",
      role: "Finance Head",
      desc: "Oversees financial planning, compliance budgeting, and operational cost management.",
      img: member4,
    },
    {
      id: 5,
      name: "YUVASRI B",
      role: "Technical Support Engineer",
      desc: "Handles in-depth technical aspects throughout the BIS certification journey,including technical requirements,testing,documentation and BIS-related queries.",
      img: member8,
    },
    {
      id: 6,
      name: "SAKTHI ROSHINI A",
      role: "Technical Support Engineer",
      desc: "Handles in-depth technical aspects throughout the BIS certification journey,including technical requirements,testing,documentation and BIS-related queries.",
      img: member7,
    },
    {
      id: 7,
      name: "Adhikari Nikhil Venkata sai",
      role: "Junior Consultant",
      desc: "Supports BIS certification processes, training programs, and quality system maintenance.",
      img: member6,
    },
    
  ];

  return (
    <div className="team-background">
      <div className="team-title">OUR EXPERT TEAM</div>
      <div className="team-sub-title">
        Meet our team of experienced engineers and certification specialists dedicated to your success.
      </div>

      <div className="team-grid">
  {[...members, ...members].map((member, index) => (
    <div className="team-card" key={index}>
      <img src={member.img} alt={member.name} className="team-img" />
      <div className="team-name">{member.name}</div>
      <div className="team-role">{member.role}</div>
      <div className="team-desc">{member.desc}</div>
    </div>
  ))}
</div>

    </div>
  );
}

export default Team;
